import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LoadingButton from '@mui/lab/LoadingButton';
import { signIn } from 'aws-amplify/auth';
import Form from '../../Common/Form/Form';
import styles from './SignIn.module.scss';
import FormTextField from '../../Common/FormTextField/FormTextField';
import UnauthenticatedRoute from '../../../_functional/UnauthenticatedRoute';
import FormAlert from '../../Common/FormAlert/FormAlert';

function SignIn() {
  const navigate = useNavigate();
  const [formAlert, setFormAlert] = React.useState(null);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  async function onSubmit(data) {
    setIsSubmitting(true);
    try {
      const { nextStep } = await signIn({
        username: data.email,
        password: data.password,
      });
      if (nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
        let userAttributesFragment = `&message=You need to change your password before signing in.&messageTitle=Password change required.`;
        // TODO: Ideally, the attributes should include '&firstName=...&lastName=...' parameters here.
        //  potentially using: "fetchUserAttributes();" (from aws-amplify/auth) if it's available in this context.
        //  see https://docs.amplify.aws/gen1/react/build-a-backend/auth/auth-migration-guide/#authuserattributes
        navigate(`/account/completeSignup?email=${data.email}&code=${data.password}${userAttributesFragment}`);
      }
    } catch (error) {
      console.error(error);
      setIsSubmitting(false);
      setFormAlert({
        severity: 'error',
        title: 'Could not sign in!',
        message:
          'Something went wrong during sign-in. Please make sure that your username and password are correct, and that you have confirmed your e-mail address.',
      });
    }
  }

  return (
    <div className={styles.signIn}>
      <h1>Sign In</h1>
      <p className={styles.description}>
        Use the form below to sign-in to your account. If you need an account, you can{' '}
        <Link to="/account/signup">create one here</Link>.
      </p>
      <p className={styles.description} />
      <Form onSubmit={(data) => onSubmit(data)}>
        <FormTextField
          name="email"
          label="E-mail address"
          autocomplete="email"
          rules={{
            required: { value: true, message: 'E-mail address is required.' },
            pattern: {
              value: /^\S+@\S+$/i,
              message: 'E-mail address must be a valid e-mail.',
            },
          }}
        />
        <FormTextField
          name="password"
          label="Password"
          type="password"
          autocomplete="current-password"
          rules={{
            required: { value: true, message: 'Password is required.' },
          }}
        />
        <div className={styles.formControls}>
          <LoadingButton variant="contained" type="submit" loading={isSubmitting} fullWidth>
            <span>Sign In</span>
          </LoadingButton>
        </div>
        <p className={styles.description}>
          <Link to="/account/requestPasswordReset">Forgot password?</Link>
        </p>
        {formAlert && <FormAlert alert={formAlert} />}
      </Form>
    </div>
  );
}

export default UnauthenticatedRoute(SignIn);
